import React from "react"

import styles from "./form.module.css"

interface DescriptionPreviewProps {
  content: string
  className?: string
}

const DangerouslyHTMLTextPriview = ({ content, className = "" }: DescriptionPreviewProps) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      className={`${styles.customForm} ${className ?? ""}`}
    />
  )
}

export default DangerouslyHTMLTextPriview
